import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useParams } from "react-router-dom";

export default function ActivityFormPage() {
    const { id } = useParams(); // id موجود فقط عند التعديل
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    // الحقول
    const [activityType, setActivityType] = useState("");
    const [activitySpecialty, setActivitySpecialty] = useState("");
    const [description, setDescription] = useState("");
    const [isActive, setIsActive] = useState(true);

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    // جلب بيانات النشاط عند التعديل
    useEffect(() => {
        if (!id) return; // إذا إضافة، لا نحتاج لجلب بيانات
        const fetchActivity = async () => {
            try {
                const res = await backEnd_request.get(`/Activities/${id}`);
                const act = res.data;

                // التأكد من أن القيم صالحة للـ inputs
                setActivityType(act.activityType ?? "");
                setActivitySpecialty(act.activitySpecialty ?? "");
                setDescription(act.description ?? "");
                setIsActive(act.isActive ?? true);
            } catch (err) {
                console.log(err.response?.data || err);
                setErrorMessage("فشل جلب بيانات النشاط");
            }
        };
        fetchActivity();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        const payload = {
            activityType: activityType.trim(),
            activitySpecialty: activitySpecialty.trim(),
            description: description.trim(),
            isActive,
        };

        try {
            if (id) {
                // تعديل
                await backEnd_request.put(`/Activities/${id}`, payload);
                navigate("/activities-management", { state: { successMessage: "تم تعديل النشاط بنجاح ✅" } });
            } else {
                // إضافة
                await backEnd_request.post("/Activities", payload);
                navigate("/activities-management", { state: { successMessage: "تم إضافة النشاط بنجاح ✅" } });
            }
        } catch (err) {
            console.log(err.response?.data || err);
            setErrorMessage(err.response?.data?.message || "حدث خطأ أثناء الحفظ");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container py-5">
            <h3 className="fw-bold text-primary mb-4">
                {id ? "تعديل النشاط" : "إضافة نشاط جديد"}
            </h3>

            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

            <form key={id || "new"} onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">نوع النشاط</label>
                    <input
                        type="text"
                        className="form-control"
                        value={activityType}
                        onChange={(e) => setActivityType(e.target.value)}
                        required
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">تخصص النشاط</label>
                    <input
                        type="text"
                        className="form-control"
                        value={activitySpecialty}
                        onChange={(e) => setActivitySpecialty(e.target.value)}
                        required
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">الوصف</label>
                    <textarea
                        className="form-control"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        rows={3}
                        required
                    />
                </div>

                <div className="form-check mb-4">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                        id="isActiveCheck"
                    />
                    <label className="form-check-label" htmlFor="isActiveCheck">
                        النشاط نشط
                    </label>
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? "جاري الحفظ..." : id ? "تعديل النشاط" : "إضافة النشاط"}
                </button>
                <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={() => navigate("/activities-management")}
                >
                    إلغاء
                </button>
            </form>
        </div>
    );
}
